





























































































































































































































































































































import {Component} from 'vue-property-decorator';
import {usersModule} from '@/store/modules/users';
import {SET_USERS} from '@/store/mutationTypes';
import {mixins} from 'vue-class-component';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import LoadingMixin from '@/mixins/LoadingMixin';
import {Biodata, biodataModule} from '@/store/modules/biodata';
import {toDate} from '@/utils/filters';
import {swalSuccess, swalError} from '@/plugins/swal';

@Component
export default class FormBiodata extends mixins(LoadingMixin, SnackbarMixin) {
  @biodataModule.State('biodatas') biodatas!: Biodata[];
  @usersModule.Mutation(SET_USERS) setUsers!: Function;
  isLoading = true;
  disableButton = false;
  menu = false;
  form = {
    name: '',
    nik: '',
    gender: '',
    birth_date: '',
    religion: '',
    hobby: '',
    marital_status: '',
    hight: '',
    wight: '',
    phonenumber1: '',
    phonenumber2: '',
    whatsapp: '',
    telephone: '',
    email: '',
    facebook: '',
    instagram: '',
    linkedn: '',
    radioGroup: null,
  };
  radioGroup = null;
  swalOption = {
    title: 'Profile',
    text: 'Apakah anda ingin mengubah Profile?',
    type: 'question',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No',
  };
  listReligion = [
    'Islam',
    'Protestan',
    'Katolik',
    'Hindu',
    'Buddha',
    'Khonghucu',
  ];
  listGender = [this.$t('male'), this.$t('female')];
  listMarital = [
    {
      id: 11,
      name: 'Tidak Kawin',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'TK',
    },
    {
      id: 12,
      name: 'Kawin Tanpa Anak',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'K0',
    },
    {
      id: 13,
      name: 'Kawin Anak 1',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'K1',
    },
    {
      id: 14,
      name: 'Kawin Anak 2',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'K2',
    },
    {
      id: 15,
      name: 'Kawin Anak 3',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'K3',
    },
    {
      id: 16,
      name: 'Kawin Anak 4',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'K4',
    },
    {
      id: 17,
      name: 'Kawin Anak 5',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'K5',
    },
    {
      id: 18,
      name: 'Kawin Anak 6',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'K6',
    },
    {
      id: 19,
      name: 'Kawin Anak 7',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'K7',
    },
    {
      id: 20,
      name: 'Kawin Anak 8',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'K8',
    },
    {
      id: 21,
      name: 'Kawin Anak 9',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'K9',
    },
    {
      id: 22,
      name: 'Kawin Anak 10',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'K10',
    },
    {
      id: 23,
      name: 'Duda Tanpa Anak',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'D0',
    },
    {
      id: 24,
      name: 'Duda Anak 1',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'D1',
    },
    {
      id: 25,
      name: 'Duda Anak 2',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'D2',
    },
    {
      id: 26,
      name: 'Duda Anak 3',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'D3',
    },
    {
      id: 27,
      name: 'Duda Anak 4',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'D4',
    },
    {
      id: 28,
      name: 'Duda Anak 5',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'D5',
    },
    {
      id: 29,
      name: 'Duda Anak 6',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'D6',
    },
    {
      id: 30,
      name: 'Duda Anak 7',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'D7',
    },
    {
      id: 31,
      name: 'Duda Anak 8',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'D8',
    },
    {
      id: 32,
      name: 'Duda Anak 9',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'D9',
    },
    {
      id: 33,
      name: 'Duda Anak 10',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'D10',
    },
    {
      id: 34,
      name: 'Janda Tanpa Anak',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'J0',
    },
    {
      id: 35,
      name: 'Janda Anak 1',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'J1',
    },
    {
      id: 36,
      name: 'Janda Anak 2',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'J2',
    },
    {
      id: 37,
      name: 'Janda Anak 3',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'J3',
    },
    {
      id: 38,
      name: 'Janda Anak 4',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'J4',
    },
    {
      id: 39,
      name: 'Janda Anak 5',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'J5',
    },
    {
      id: 40,
      name: 'Janda Anak 6',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'J6',
    },
    {
      id: 41,
      name: 'Janda Anak 7',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'J7',
    },
    {
      id: 42,
      name: 'Janda Anak 8',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'J8',
    },
    {
      id: 43,
      name: 'Janda Anak 9',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'J9',
    },
    {
      id: 44,
      name: 'Janda Anak 10',
      created_at: '2019-01-01T00:00:00.000Z',
      updated_at: '2019-01-01T00:00:00.000Z',
      code: 'J10',
    },
  ];
  get rules() {
    return {
      name: 'required',
      nik: 'numeric',
      gender: 'required',
      birth_date: 'required',
      religion: 'required',
      hobby: 'required',
      marital_status: 'required',
      hight: 'required|numeric',
      wight: 'required|numeric',
      phonenumber1: 'required|numeric',
      phonenumber2: 'numeric',
      whatsapp: 'required|numeric',
      telephone: 'numeric',
      email: 'required|email',
      facebook: '',
      instagram: '',
      linkedn: '',
    };
  }
  async mounted() {
    await this.fetchDetail();
  }
  toDateConvert(val: any) {
    toDate(val);
  }
  destroyed() {
    this.setUsers([]);
  }
  async fetchDetail() {
    try {
      this.startLoading('detail');
      const {data} = await this.$store.dispatch('biodata/getBiodata');
      this.finishLoading('detail');

      if (data !== null) {
        this.form = data;
        this.form.birth_date = data.birth_date ? toDate(data.birth_date) : '';
      }
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.catchError(e);
    }
  }
  async onSubmit() {
    try {
      this.startLoading('saving');
      const res = await this.$store.dispatch(
        'biodata/updateBiodata',
        this.form,
      );

      if (res.status === 200) {
        swalSuccess.fire({
          title: 'Success!',
          text: res.data.message,
        });
        this.finishLoading('saving');
      }
      this.disableButton = false;
      this.fetchDetail();

      this.$emit('nextStep', 2);
    } catch (e) {
      swalError.fire({
        title: 'Failed!',
        text:
          e.response?.error?.message ||
          'Sebuah kesalahan yang tidak diduga telah terjadi.',
      });
    }
  }
}
